(() => {
  const focusConfirmation = () => {
    const confirmation = document.getElementById('guest-list-thanks');
    if (!confirmation) return;
    const skipLink = document.querySelector('.skip-link');
    if (skipLink) { skipLink.href = '#guest-list-thanks'; skipLink.textContent = 'Skip to signup confirmation'; }
    document.title = 'You’re on the guest list — Mosey & Tuck';
    confirmation.focus({ preventScroll: true });
    const showConfirmation = () => {
      const card = confirmation.closest('.silk-panel');
      const bounds = card.getBoundingClientRect();
      if (bounds.top < 0 || bounds.bottom > innerHeight) card.scrollIntoView({ block: 'center', behavior: 'instant' });
    };
    if (document.readyState === 'complete') showConfirmation();
    else window.addEventListener('load', showConfirmation, { once: true });
  };
  focusConfirmation();

  const signup = document.getElementById('MoseyGuestList');
  const successTemplate = document.getElementById('MoseyGuestListSuccess');
  if (signup && successTemplate && signup.dataset.companyId && signup.dataset.listId) {
    const email = signup.querySelector('input[type="email"]');
    const button = signup.querySelector('button[type="submit"]');
    const status = signup.querySelector('#form-status');
    let submitting = false;
    signup.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting || !signup.reportValidity()) return;
      submitting = true;
      button.disabled = true;
      signup.setAttribute('aria-busy', 'true');
      status.removeAttribute('data-state');
      status.textContent = 'Joining the guest list…';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        // Klaviyo's public browser endpoint records explicit email consent.
        // No private API credentials or Shopify account/checkout endpoints are used.
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(signup.dataset.companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2026-07-15' },
          signal: controller.signal,
          body: JSON.stringify({ data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Mosey & Tuck homepage guest list',
              profile: { data: { type: 'profile', attributes: {
                email: email.value.trim()
              } } }
            },
            relationships: { list: { data: { type: 'list', id: signup.dataset.listId } } }
          } })
        });
        if (response.status !== 202) {
          const error = new Error('Subscription was not accepted');
          error.rateLimited = response.status === 429;
          throw error;
        }
        const panel = signup.querySelector('.silk-panel');
        panel.replaceChildren(successTemplate.content.cloneNode(true));
        panel.classList.add('is-success');
        panel.setAttribute('aria-label', 'Guest list signup confirmed');
        signup.removeAttribute('aria-busy');
        focusConfirmation();
      } catch (error) {
        status.dataset.state = 'error';
        status.textContent = error.rateLimited
          ? 'Please wait a moment, then try joining again.'
          : 'We couldn’t confirm your signup. Please try again, or email hello@moseyandtuck.com.';
        signup.removeAttribute('aria-busy');
        button.disabled = false;
        submitting = false;
      } finally {
        clearTimeout(timeout);
      }
    });
    // Keep the form inert until the submit handler is installed; no email in URLs.
    email.disabled = false;
    button.disabled = false;
  }
  const access = document.getElementById('MoseyStoreAccess');
  if (access?.querySelector('.errors')) access.closest('details').open = true;
  const video = document.getElementById('hero-video');
  const toggle = document.getElementById('motion-toggle');
  if (!video || !toggle || video.dataset.enableMotion !== 'true') return;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  let pausedByUser = false;
  const play = () => {
    if (preference.matches || navigator.connection?.saveData || pausedByUser || document.hidden) return;
    if (!video.src) video.src = video.dataset.videoSrc;
    video.play().then(() => {
      video.classList.add('is-playing'); toggle.hidden = false; toggle.textContent = 'Pause background';
    }).catch(() => video.classList.remove('is-playing'));
  };
  toggle.addEventListener('click', () => {
    pausedByUser = !video.paused;
    if (pausedByUser) { video.pause(); toggle.textContent = 'Play background'; }
    else play();
  });
  preference.addEventListener('change', () => {
    if (preference.matches) { video.pause(); video.classList.remove('is-playing'); toggle.hidden = true; }
    else play();
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); });
  window.addEventListener('load', play, { once: true });
})();
